import { countryOptions } from '@common/country';
import { InputMask } from '@components/atoms';

import { DatePicker, Form, Input, Radio, Select } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

interface FormPersonalDataProps {
  prefix: string;
  isSpouse?: boolean;
}

export const FormPersonalData = ({
  prefix,
  isSpouse = false,
}: FormPersonalDataProps) => {
  const birthday = Form.useWatch([prefix, 'birthday']);
  const [age, setAge] = useState<string>('');

  useEffect(() => {
    if (birthday) {
      const years = dayjs().diff(birthday, 'year');
      setAge(`${years} years`);
    } else {
      setAge('');
    }
  }, [birthday]);

  return (
    <>
      <Form.Item
        label='Nome completo'
        name={[prefix, 'name']}
        rules={[{ required: true, message: 'Campo obrigatório' }]}
      >
        <Input placeholder='Digite o nome completo' />
      </Form.Item>

      <div className='grid grid-cols-1 md:grid-cols-2 md:gap-x-6'>
        <div className='flex gap-4 items-start w-full'>
          <Form.Item
            label='Data de nascimento'
            name={[prefix, 'birthday']}
            rules={[{ required: true, message: 'Campo obrigatório' }]}
            className='flex-1'
          >
            <DatePicker
              placeholder='MM/DD/YYYY'
              className='w-full'
              format={{
                format: 'MM/DD/YYYY',
                type: 'mask',
              }}
              inputReadOnly={true}
              open={false}
              onChange={(date) => {
                if (date) {
                  const years = dayjs().diff(date, 'year');
                  setAge(`${years} years`);
                } else {
                  setAge('');
                }
              }}
            />
          </Form.Item>

          {age && (
            <Form.Item
              label='Idade'
              className='mt-[32px]'
            >
              <Input
                value={age}
                disabled
                className='bg-gray-50 border-gray-200'
              />
            </Form.Item>
          )}
        </div>

        <Form.Item
          label='Gênero'
          name={[prefix, 'gender']}
          rules={[{ required: true, message: 'Campo obrigatório' }]}
        >
          <Radio.Group>
            <Radio value='male'>Masculino</Radio>
            <Radio value='female'>Feminino</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label='CPF'
          name={[prefix, 'cpf']}
        >
          <InputMask size='large' placeholder='000.000.000-00' mask='cpf' />
        </Form.Item>

        <Form.Item
          label='País de origem'
          name={[prefix, 'nationality']}
        >
          <Select
            placeholder='Selecione o país de origem'
            size='large'
            options={countryOptions}
          />
        </Form.Item>

        <Form.Item
          label='Telefone'
          name={[prefix, 'phone']}
        >
          <InputMask mask='phone' placeholder='Digite o telefone' />
        </Form.Item>

        <Form.Item
          label='E-mail'
          name={[prefix, 'email']}
        >
          <Input placeholder='Digite o e-mail' type='email' />
        </Form.Item>

        <Form.Item label='Profissão' name={[prefix, 'profession']}>
          <Input placeholder='Digite a profissão' />
        </Form.Item>

        <Form.Item label='Renda mensal' name={[prefix, 'monthlyIncome']}>
          <InputMask mask='money' placeholder='R$ 0,00' />
        </Form.Item>

        <Form.Item label='Estado civil' name={[prefix, 'maritalStatus']} rules={[{ required: true, message: 'Campo obrigatório' }]}>
          <Select
            placeholder='Selecione o estado civil'
            size='large'
            options={[]}
            disabled={isSpouse}
          />
        </Form.Item>
      </div>
    </>
  );
};
